module.exports = __webpack_public_path__ + "static/media/inline-delete.fd6ca5ba.svg";